import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import evieLogo from 'assets/images/logo-letter.png';

const SinglePayment = ({ children, staticimg }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className={`single-payment ${staticimg ? 'staticimg' : ''}`}>
      <img src={evieLogo} alt="Evie logo" className="single-payment__logo" />
      {children}
    </section>
  );
};

SinglePayment.defaultProps = {
  staticimg: false,
};

SinglePayment.propTypes = {
  children: PropTypes.node.isRequired,
  staticimg: PropTypes.bool,
};

export default SinglePayment; 